<template>

<div>


<!-- heading page / start-->
<div class="heading-page heading-page-1 bg-cover next-header bg-darkblue">
    <div class="container p-l-60 p-r-60 p-x-md-20 wow slideInLeft">
        <!-- <ul class="breadcrumbs">
            <li>
                <a href="/">Inicio</a>
            </li>
            <li>
                <a href="#">Contáctame</a>
            </li>
        </ul> -->
        <h3 class="title">Contáctame</h3>
    </div>
</div>
<!-- heading page / end-->
<!-- section contact form / start-->

<section class="section bg-white p-t-50 p-b-60 bg-light-deg">
    <div class="container p-l-60 p-r-60 p-x-md-20">

    <div class="row">
        <div class="col-md-12 text-contact p-b-40">
            <p class="text-justify">Si deseas que te ayude, asesore y acompañe durante todo el proceso de compra, venta o alquiler de tu inmueble no dudes en indicarme cuándo, que gustoso te atenderé y juntos lograremos tu objetivo. ¡¡ Soy tu mejor opción !!</p>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-5 col-lg-offset-1 col-md-6 col-md-offset-0 col-sm-8 col-sm-offset-2 col-xs-12"> <!-- col-md-offset-3 -->
            <div id="form-contact">
                <!-- <h3 class="text-block text-black text-bold text-med m-b-10 text-center">Envíanos un Mensaje:</h3> -->
                <div class="heading-section heading-section-2 dark" style="padding-bottom: 20px">
                    <h3 style="font-size:21px;color:#333">Quiero que me llamen</h3>
                </div>


                <div v-if="errors" class="card border-danger mb-3">
                <div class="card-header" style="color:#3398a9;">Se han encontrado los siguientes errores</div>
                <div class="card-body text-danger">
                    <ul>
                        <div v-for="(v, k) in errors" :key="k">
                            <li><small v-for="error in v" :key="error">{{ error }}</small></li>
                        </div>
                    </ul>
                </div>
                </div>

                 <form role="form" @submit.prevent="sendContactForm()">

                    <div class="au-form-group">

                        <div class="au-form-col-12 form-group" style="margin:0 5px;">

                            <input class="au-input au-input-2" type="text" placeholder="Nombre" autocomplete="off" v-model="formData.name">
                        </div>
                         <div class="au-form-col-12 form-group" style="margin:0 5px;">

                            <input class="au-input au-input-2" type="text" placeholder="Email" autocomplete="off" v-model="formData.email">
                        </div>
                         <div class="au-form-col-12 form-group" style="margin:0 5px;">

                            <input class="au-input au-input-2" type="tel" placeholder="Celular" autocomplete="off" v-model="formData.cell_phone">
                        </div>

                        <div class="au-form-col-12 form-group" style="margin:0 5px;">
                            <select class="au-input au-input-2" v-model="formData.day">
                              <option value="" selected disabled>-- Día --</option>
                              <option value="Lunes">Lunes</option>
                              <option value="Martes">Martes</option>
                              <option value="Miércoles">Miércoles</option>
                              <option value="Jueves">Jueves</option>
                              <option value="Viernes">Viernes</option>
                              <option value="Sábado">Sábado</option>
                              <option value="Domingo">Domingo</option>

                            </select>
                        </div>

                        <div class="au-form-col-12 form-group" style="margin:0 5px;">
                            <select class="au-input au-input-2" v-model="formData.hour">
                              <option value="" selected disabled>-- Hora --</option>
                              <option value="9 am">9 am</option>
                              <option value="10 am">10 am</option>
                              <option value="11 am">11 am</option>
                              <option value="12 pm">12 pm</option>
                              <option value="1 pm">1 pm</option>
                              <option value="2 pm">2 pm</option>
                              <option value="3 pm">3 pm</option>
                              <option value="4 pm">4 pm</option>
                              <option value="5 pm">5 pm</option>
                              <option value="6 pm">6 pm</option>
                              <option value="7 pm">7 pm</option>
                              <option value="8 pm">8 pm</option>
                              <option value="9 pm">9 pm</option>
                            </select>
                        </div>

                        <div class="au-form-col-12 form-group" style="margin:0 5px;">
                            <select class="au-input au-input-2" v-model="formData.reason">
                              <option value="" selected disabled>-- Motivo --</option>
                              <option value="Quiero Comprar">Quiero Comprar</option>
                              <option value="Quiero Vender">Quiero Vender</option>
                              <option value="Quiero Alquilar">Quiero Alquilar</option>
                            </select>
                        </div>


                    </div>

                    <div class="au-form-group text-right text-center-sm">
                        <button class="au-btn au-btn-primary" type="submit" id="contactBtn" style="background:#000056">
                            <img src="landing/loading.gif" id="loadingImage" style="width: 30px; display: none;" alt="" srcset="">
                            Enviar
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-lg-5 col-md-6 col-md-offset-0 col-sm-8 col-sm-offset-2 col-xs-12 contact-area d-flex d-column dx-between wow slideInRight">
            <div class=""> <!--icon-group-->

                <div class="row-box d-flex">
                    <p><i class="fa fa-envelope fa-lg"></i></p>
                    <p class="text-center-sm">
                        <a href="https://agentejuancolca.com" target="_blank">www.agentejuancolca.com</a><br>
                        <a href="mailto:juan.colca@gmail.com">juan.colca@gmail.com</a>
                    </p>
                </div>
                <div class="row-box d-flex">
                    <p><i class="fa fa-map-marker fa-lg"></i></p>
                    <p class="text-center-sm">
                        <span style="display:block">Calle Monte Rosa 233</span>
                        <span style="display:block">Chacarilla, Surco</span>
                    </p>
                </div>
                <div class="row-box d-flex">
                    <p><i class="fa fa-mobile fa-lg"></i></p>
                    <p class="text-center-sm">
                        <span>Whatsapp</span><br>
                        <a href="https://api.whatsapp.com/send?phone=51944541269&text=Hola%20necesito%20informacion%20sobre%20sus%20servicios" target="_blank">+51 944 541 269</a>
                    </p>
                </div>

            </div>
        </div>
    </div>


    </div>
</section>

</div>

</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {

    data() {
        return {
            formData: {
                name: '',
                email: '',
                cell_phone: '',
                day: '',
                hour: '',
                reason: '',
            },
            errors: null
        }
    },

    methods: {

        sendContactForm() {
            const btnSend = document.getElementById('contactBtn');
            const loadingImg = document.getElementById('loadingImage');

            btnSend.disabled = true;
            loadingImg.style.display = 'inline';

            axios.post('/contact', this.formData)
                .then(response => {
                    swal("¡Solicitud enviada!", response.data.success, "success");
                    this.formData = {
                        name: '',
                        email: '',
                        cell_phone: '',
                        day: '',
                        hour: '',
                        reason: '',
                    }
                    this.errors = null;
                    btnSend.disabled = false;
                    loadingImg.style.display = 'none';
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                    btnSend.disabled = false;
                    loadingImg.style.display = 'none';
                })
        }
    },

}
</script>
